import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bav-leistung"
export default class extends Controller {
	static targets = ["select", "fuenftelregelung", "teilkapitalisierung", "infotextRentenzahlung", "infotextKapitalauszahlung"]

	connect() {
		this.updateModus()
	}

	updateModus() {
		this.hideAllElements()

		switch (this.selectTarget.value) {
			case "kapitalauszahlung":
				this.showFuenftelregelung()
				this.showInfotextKapitalauszahlung()
				break
			case "rentenzahlung":
				this.showTeilkapitalisierung()
				this.showInfotextRentenzahlung()
				break
		}
	}

	// Private Methods

	hideAllElements() {
		if (this.hasFuenftelregelungTarget) this.fuenftelregelungTarget.classList.add("hidden")
		if (this.hasTeilkapitalisierungTarget) this.teilkapitalisierungTarget.classList.add("hidden")
		if (this.hasInfotextRentenzahlungTarget) this.infotextRentenzahlungTarget.classList.add("hidden")
		if (this.hasInfotextKapitalauszahlungTarget) this.infotextKapitalauszahlungTarget.classList.add("hidden")
	}

	showFuenftelregelung() {
		if (this.hasFuenftelregelungTarget) this.fuenftelregelungTarget.classList.remove("hidden")
	}

	showTeilkapitalisierung() {
		if (this.hasTeilkapitalisierungTarget) this.teilkapitalisierungTarget.classList.remove("hidden")
	}

	showInfotextRentenzahlung() {
		if (this.hasInfotextRentenzahlungTarget) this.infotextRentenzahlungTarget.classList.remove("hidden")
	}

	showInfotextKapitalauszahlung() {
		if (this.hasInfotextKapitalauszahlungTarget) this.infotextKapitalauszahlungTarget.classList.remove("hidden")
	}
}
